module.exports = {
  "zones": {
    "Indian/Chagos": ["z", {
      "wallclock": 820454400000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 820436400000,
      "save": 0
    }, {
      "wallclock": -1988150400000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": -1988167780000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 17380000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};